export enum OfferRequestStatus {
  Created = 1,
  Sent = 2,
  Cancelled = 7,
  Expired = 8
}

(OfferRequestStatus as any).__typeName = 'OfferRequestStatus';
